import type {
    LocationPagePropertyOnboardingContextFieldsV2,
    LocationPagePropertyOnboardingContextIdsV2,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BuildingElementPropertyOnboardingManifestV1,
    CityElementPropertyOnboardingManifestV1,
    CountryRegionElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    LocationEnterManuallyElementPropertyOnboardingManifestV1,
    LocationGoogleMapElementPropertyOnboardingManifestV1,
    LocationSearchFieldElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
    StateProvinceElementPropertyOnboardingManifestV1,
    StreetAddressElementPropertyOnboardingManifestV1,
    ZipPostalCodeElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    LocationPagePropertyOnboardingContextManifestV2,
    WebListYourPropertyLocationVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/location-page";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const locationBinder = defineBinder(({ webAnalytics, action: { click } }) => {
    webAnalytics.pageContext<LocationPagePropertyOnboardingContextIdsV2, LocationPagePropertyOnboardingContextFieldsV2>(
        LocationPagePropertyOnboardingContextManifestV2.ids,
        {
            auth_user_id: BaseContextFieldsMapping.auth_user_id,
            member_id: BaseContextFieldsMapping.member_id,
            property_id: BaseContextFieldsMapping.property_id,
            onboarding_id: BaseContextFieldsMapping.onboarding_id,
            is_internal_user: BaseContextFieldsMapping.is_internal_user,
        },
    );

    webAnalytics.observe(WebListYourPropertyLocationVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], LocationSearchFieldElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], LocationEnterManuallyElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], LocationGoogleMapElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CountryRegionElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], StateProvinceElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CityElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], StreetAddressElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BuildingElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ZipPostalCodeElementPropertyOnboardingManifestV1.ids, {});
});
